<form class="row" [formGroup]="form">
  <div class="col-md-4 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix() + 'street' | qaSlug">
    <label class="control-label" for="{{ uniqueId + '-street' }}">Street Address <span class="color-danger">*</span> </label>
    <input data-private class="txt-box form-control" maxlength="50" pInputText formControlName="street" id="{{ uniqueId + '-street' }}" />
    <cmg-validator-messages [control]="form.get('street')" />
  </div>
  <div class="col-lg-4 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'zipCode' | qaSlug">
    <label class="control-label">Zip Code <span class="color-danger">*</span></label>
    <cmg-form-control-zip-code formControlName="zipCode" [inputId]="uniqueId + '-zipCode'" (change)="onZipCodeChanged($event)" />
    <cmg-validator-messages [control]="form.get('zipCode')" />
  </div>
  <div class="col-md-4 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix() + 'city' | qaSlug">
    <label class="control-label" for="{{ uniqueId + '-city' }}">City <span class="color-danger">*</span></label>
    <input data-private class="txt-box form-control" maxlength="50" pInputText formControlName="city" id="{{ uniqueId + '-city' }}" />
    <cmg-validator-messages [control]="form.get('city')" />
  </div>

  <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'state' | qaSlug">
    <label class="control-label" for="{{ uniqueId + '-state' }}">State <span class="color-danger">*</span></label>
    <p-select
      data-private
      class="w-100"
      [options]="states"
      formControlName="state"
      [optionLabel]="'name'"
      [optionValue]="'id'"
      id="{{ uniqueId + '-state' }}"
      appendTo="body"
    />
    <cmg-validator-messages [control]="form.get('state')" />
  </div>
  <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'addressType' | qaSlug">
    <label class="control-label" for="{{ uniqueId + '-addressType' }}">Living Status <span class="color-danger">*</span></label>
    <p-select
      data-private
      class="w-100"
      [options]="livingStatusOptions$ | async"
      formControlName="addressType"
      [optionLabel]="'name'"
      [optionValue]="'value'"
      id="{{ uniqueId + '-addressType' }}"
      appendTo="body"
    />
    <cmg-validator-messages [control]="form.get('state')" />
  </div>
  <div class="col-lg-4 col-xs-6 form-group d-flex flex-column">
    <div class="d-flex flex-column me-2" [attr.automation-id]="autoIdPrefix() + 'years' | qaSlug">
      <label class="control-label" for="{{ uniqueId + '-years' }}"
        >Years
        @if (!previousAddressMode()) {
          <span class="color-danger">*</span>
        }
      </label>
      <p-inputNumber class="w-200" id="{{ uniqueId + '-years' }}" formControlName="years" name="years" [min]="0" [max]="100" />
      <cmg-validator-messages [control]="form.get('years')" />
    </div>
  </div>
  <div class="col-lg-4 col-xs-6 form-group d-flex flex-column">
    <div class="d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'months' | qaSlug">
      <label class="control-label" for="{{ uniqueId + '-months' }}"
        >Months
        @if (!previousAddressMode()) {
          <span class="color-danger">*</span>
        }
      </label>
      <p-inputNumber class="w-200" id="{{ uniqueId + '-months' }}" formControlName="months" name="months" [min]="0" [max]="11" />
      <cmg-validator-messages [control]="form.get('months')" />
    </div>
  </div>
</form>
